import { IStoreWithLayouts } from './store';

export const getLayoutState = (state: IStoreWithLayouts) => state.layouts;
